import { ROUTER_PATHS } from "~/routes/constants"
import { ADMIN_PAGES } from "./admin_pages"

const ADMIN_NAVBAR_ITEMS: Array<{
  name: string
  key: string
  href: string
  route?: string
  routes?: string[]
}> = [
  {
    name: "Reservations",
    key: ADMIN_PAGES.RESERVATIONS,
    href: "/admin/reservations",
  },
  {
    name: "To-do's",
    key: ADMIN_PAGES.TO_DOS,
    href: ROUTER_PATHS.ADMIN_TODOS,
    route: ROUTER_PATHS.ADMIN_TODOS,
    routes: [ROUTER_PATHS.ADMIN_TODOS],
  },
  {
    name: "Reports",
    key: ADMIN_PAGES.REPORTS,
    href: "/admin/reservations",
  },
  {
    name: "Invoices",
    key: ADMIN_PAGES.INVOICES,
    href: "/admin/reservations",
  },
  {
    name: "Guests",
    key: ADMIN_PAGES.GUESTS,
    href: ROUTER_PATHS.ADMIN_GUESTS,
    route: ROUTER_PATHS.ADMIN_GUESTS,
    routes: [ROUTER_PATHS.ADMIN_GUESTS],
  },
  {
    name: "Store",
    key: ADMIN_PAGES.STORE,
    href: ROUTER_PATHS.ADMIN_STORE_POS,
    route: ROUTER_PATHS.ADMIN_STORE_POS,
    routes: [ROUTER_PATHS.ADMIN_STORE_POS, ROUTER_PATHS.ADMIN_STORE_HISTORY],
  },
  {
    name: "Settings",
    key: ADMIN_PAGES.SETTINGS,
    href: ROUTER_PATHS.ADMIN_SETTINGS_CAMP_INFO,
    route: ROUTER_PATHS.ADMIN_SETTINGS_CAMP_INFO,
    routes: [
      ROUTER_PATHS.ADMIN_SETTINGS,
      ROUTER_PATHS.ADMIN_SETTINGS_AUTOMATED_MESSAGES,
      ROUTER_PATHS.ADMIN_SETTINGS_CAMP_INFO,
      ROUTER_PATHS.ADMIN_SETTINGS_COUPONS,
      ROUTER_PATHS.ADMIN_SETTINGS_INVOICES,
      ROUTER_PATHS.ADMIN_SETTINGS_PRICES,
      ROUTER_PATHS.ADMIN_SETTINGS_RULES_TERMS,
      ROUTER_PATHS.ADMIN_SETTINGS_USERS,
      ROUTER_PATHS.ADMIN_SETTINGS_RESERVATION_IMPORT,
      ROUTER_PATHS.ADMIN_SETTINGS_CAMPER_IMPORT,
    ],
  },
]

export default ADMIN_NAVBAR_ITEMS
